 
import getSWRMiddleware from './getSWRMiddleware'

export default getSWRMiddleware
